<div *ngIf="isEditable()" class="display-name-input" [formGroup]="field_name">
    <div class="form-group">
        <div [style.width.px]="columnActualWidth">
            <cxone-text-input id="fieldName" type="text" class="text-input" textInputId="text-input-2"
                [(ngModel)]="params.node.data.fieldName" placeholder={{addFieldPlaceholder}} name="fieldName"
                [required]="isRequired" (ngModelChange)="validateField()" formControlName="fieldName"  (keydown)="onKeydown($event)">
            </cxone-text-input>
        </div>
        <div *ngIf="field_name.controls['fieldName'].errors
            && (field_name.controls['fieldName'].dirty || field_name.controls['fieldName'].touched || showError)">
            <span class="error-color"
                *ngIf="field_name.controls['fieldName'].hasError('numericPattern') && !field_name.controls['fieldName'].hasError('maxlength')"
                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Contains_Only_Numbers">Cannot use only
                numbers</span>
            <span class="error-color" *ngIf="field_name.controls['fieldName'].hasError('required')" cvLocalizedText
                langSection="ETL_Data_Feed_Create" langKey="Required_Field">This field is required</span>
            <span class="error-color"
                *ngIf="field_name.controls['fieldName'].hasError('pattern') && !field_name.controls['fieldName'].hasError('maxlength')"
                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Special_Characters">Cannot use ^ / ! \ \ +
                <> ? # & , "
            </span>
            <span class="error-color"
                *ngIf="field_name.controls['fieldName'].hasError('duplicateName') && !field_name.controls['fieldName'].hasError('numericPattern')"
                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Name_Exists">Name
                already exists</span>
            <span class="error-color" *ngIf="field_name.controls['fieldName'].hasError('maxlength')" cvLocalizedText
                langSection="ETL_Data_Feed_Create" langKey="Character_Limit">Enter upto 50 characters</span>
        </div>
    </div>
</div>
<div *ngIf="!isEditable()" class="display-name-row-text" cxoneOverflowTooltip placement="right">
    <span>{{params.node.data.fieldName}}</span>
</div>